<template>
    <div id="ActivityQnA">
        <h5>
            활동 후기
        </h5>
        <div class="row" v-if="$props.activityMemberStatus == 'COMPLETED'">
            <div class="col" style="min-height:250px;">
                <quill-editor style="height: 200px" ref="activityReview" v-model="reply.replyContents" rows="5"
                              :content="reply.replyContents"
                              :options="editorOption"
                              @change="onEditorChange($event)"
                              name="activityReview"
                              class="form-group quill-editor">
                </quill-editor>
            </div>
            <span class="btn btn-primary" v-on:click="formSubmit()" style="max-height: 200px;">작성</span>
        </div>


        <hr/>

        <ActivityReplyAnswer :reply="reply" :replyList="replyList" :isRichContent="true" :replyType="reply.replyType"
                             :isEditor="true" answerAuth="MEMBER"></ActivityReplyAnswer>

        <h4 v-if="replyList.length==0" class="text-center">
            등록된 후기가 없습니다.
        </h4>

        <button type="button" class="btn-white btn btn-block" @click="getMore()" v-if="page.pageSize == currentLength">
            더보기
        </button>
    </div>

</template>

<script>
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    import {quillEditor} from 'vue-quill-editor'

    import Quill from 'quill';

    import imageUpload from 'quill-plugin-image-upload';
    import ImageResize from 'quill-image-resize-module';
    import ActivityReplyAnswer from "../../components/activity/ActivityReplyAnswer";

    Quill.register('modules/imageUpload', imageUpload)
    Quill.register('modules/imageResize', ImageResize)

    export default {
        name: 'ActivityReview',
        components: {quillEditor, ActivityReplyAnswer},
        data() {
            return {
                editorOption: {
                    placeholder: '간략한 후기를 남겨주세요\n상세후기는 포스팅 주소를 링크 부탁드립니다.',
                    modules: {
                        toolbar: [
                            [{'size': ['small', false, 'large']}],
                            ['bold', 'italic'],
                            [{'list': 'ordered'}, {'list': 'bullet'}],
                            ['link', 'image', 'video'],
                            [{align: ''}, {align: 'center'}, {align: 'right'}, {align: 'justify'}]
                        ],
                        history: {
                            delay: 1000,
                            maxStack: 50,
                            userOnly: false
                        },
                        imageUpload: {
                            upload: file => {
                                // return a Promise that resolves in a link to the uploaded image
                                return new Promise((resolve, reject) => {
                                    this.makeUploadFiles(file, function (res) {
                                        resolve(res);
                                    })
                                });
                            }
                        },
                        imageResize: {
                            modules: ["Resize", "DisplaySize", "Toolbar"]
                        }
                    },
                },
                reply: {
                    replyContents: "",
                    activityId: 0,
                    replyType: 'REVIEW'
                },
                replyList: [],
                page: {
                    pageNum: 0,
                    pageSize: 5,
                },
                currentLength: 0,
            };
        },
        props: {
            activityMemberStatus: String,
        },

        methods: {
            popupLogin() {
                this.$modal.show('dialog', {
                    title: '회원 전용',
                    text: '로그인이 필요합니다.',
                    buttons: [
                        {
                            title: '로그인 하기',
                            handler: () => {
                                this.$router.push({name: 'login', params: {ref: this.$router.currentRoute.path}});
                                this.$modal.hide('dialog');
                            }

                        },
                        {
                            title: '닫기'
                        }
                    ]
                })
            },
            formSubmit() {
                if (this.reply.replyContents == '') {
                    this.$root.$children[0].commonDialog('리뷰 등록', '리뷰 내용을 입력하세요.');
                    //this.$refs.replyContents.focus();
                    return;
                }
                if (!this.$auth.check()) {
                    this.popupLogin()
                    return;
                } else {
                    this.reply.memberId = this.$auth.user().id;
                }
                let me = this
                this.axios.post(process.env.VUE_APP_ACTIVITY_API_URL + '/reply', this.reply)
                    .then(function (res) {
                        me.$root.$children[0].commonDialog('리뷰 등록', '리뷰가 등록 되었습니다.');
                        me.getList();
                        me.reply.replyContents = "";
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            onEditorChange({quill, html, text}) {
                this.reply.replyContents = html
            },
            onEditorBlur(quill) {
            },
            onEditorFocus(quill) {
            },
            onEditorReady(quill) {
            },

            getList() {
                let me = this;
                this.axios.get(process.env.VUE_APP_ACTIVITY_API_URL +
                    `/reply/list?activityId=${this.reply.activityId}&replyType=${this.reply.replyType}&page=${this.page.pageNum}&size=${this.page.pageSize}`)
                    .then(function (res) {
                        me.currentLength = res.data.length
                        me.replyList = res.data;
                    }).catch(function (error) {
                    console.log(error);
                });
            },

            async makeUploadFiles(file, callback) {
                let formData = new FormData();
                if (file.size > 3145728) // upper than 3MB
                    file = await this.$root.$children[0].resizeImg(file, 500);
                formData.append('sourceFile', file);
                this.$root.$children[0].uploadFile(formData, 'REVIEW').then(callback);
            },
            getMore() {
                this.page.pageSize += 5;
                this.getList();
            }
        },
        mounted() {
            this.reply.activityId = this.$route.params.id;
            this.getList();
        },
        created() {
            //console.log(this.$props.activityMemberStatus)
        }

    }
</script>
<style>
    .col img {
        max-width: 100%;
        margin-bottom: 10px;
    }
</style>
